import { createApp } from "vue";
import { createPinia } from "pinia";
import { Tooltip } from "bootstrap";
import App from "./App.vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import ElementPlus from "element-plus";
import i18n from "@/core/plugins/i18n";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";
import { initKtIcon } from "@/core/plugins/keenthemes";

import "@/core/plugins/prismjs";
import router from "./router/router";

// After a redeploy, a long-lived page (e.g. the installed PWA menu) still holds an
// index.html that references old hashed chunks — lazy-route imports then fail and
// taps appear to do nothing. Reload once to pick up the fresh build; the guard
// prevents a reload loop if the failure persists (e.g. truly offline).
function recoverFromStaleChunk() {
  const KEY = "chunk-reload-at";
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last < 15000) return; // already tried very recently
  sessionStorage.setItem(KEY, String(Date.now()));
  window.location.reload();
}
window.addEventListener("vite:preloadError", (e) => {
  e.preventDefault(); // we handle it — don't surface an unhandled rejection
  recoverFromStaleChunk();
});
router.onError((err) => {
  if (/Failed to fetch dynamically imported module|Importing a module script failed/i.test(String(err?.message))) {
    recoverFromStaleChunk();
  }
});

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(ElementPlus);

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initKtIcon(app);
initVeeValidate();

app.use(i18n);

app.directive("tooltip", (el) => {
  new Tooltip(el);
});

app.mount("#app");
